import { createNode } from '@glueapp/graph-types';

export const Clamp = createNode({
    id: 'Clamp',
    name: 'Clamp',
    description: 'Limits the value if it goes higher than the maximum or lower than the minimum',
    aiDescription:
        'Constrains a number to a range. Connect values to "Value", "Minimum", and "Maximum" input ports; the "Result" output port provides the clamped value.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Value: {
            kind: 'number',
        },
        Minimum: {
            kind: 'number',
        },
        Maximum: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        const value = input.inPorts.Value;
        const minimum = input.inPorts.Minimum;
        const maximum = input.inPorts.Maximum;
        return { output: { Result: Math.max(minimum, Math.min(value, maximum)) } };
    },
});
